var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":true,"absolute":"","opacity":"0","color":"transparent","id":"overlay"}},[_c('v-progress-circular',{attrs:{"id":"loader","indeterminate":"","color":"primary","size":"96","width":"8"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }